/**
 * Eclipse HHU theme tokens.
 *
 * The HHU uses a LIGHT theme so screens stay legible on Zebra TC handhelds
 * under bright facility lighting. The brand colour is WFM green (#006F46),
 * matching the Eclipse Portal (see Portal's wfm-theme.json palette500).
 *
 * Centralising these values here keeps the brand consistent across every
 * screen and gives us a single place to adjust the palette.
 */

export const THEME = {
  // ─── Brand (WFM green — matches Portal palette) ──────────────────────────
  brand: "#006F46", // palette500 — primary brand green
  brandDark: "#004E36", // palette600 — pressed / darker accents
  brandLight: "#2C8746", // palette400 — lighter green accent
  brandTint: "#D6ECDC", // palette50  — subtle green background wash
  onBrand: "#FFFFFF", // text/icons on a green surface

  // ─── Surfaces (light theme) ──────────────────────────────────────────────
  appBg: "#F7F8FA", // app shell background
  surface: "#FFFFFF", // cards, header bar inner, action bar
  surfaceAlt: "#F2F4F5", // subtle alternate surface
  border: "#D5DBDB", // hairline borders

  // ─── Text ────────────────────────────────────────────────────────────────
  text: "#16191F", // primary text
  textSecondary: "#5F6B7A", // secondary / muted text

  // ─── Status ────────────────────────────────────────────────────────────────
  success: "#1D8102",
  warning: "#F0883E",
  error: "#D13212",

  // ─── Focus ring (accessibility) ─────────────────────────────────────────────
  focus: "#006F46",
} as const

export type Theme = typeof THEME
